var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _circle, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g, _path146, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSosShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 226,
    viewBox: "0 0 185 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_2972)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 226,
    rx: 24,
    fill: "#0E5A90"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2227 199.982C19.3922 202.408 19.7315 233.806 16 251.625V268.542L231.746 277L235.477 154.861C242.601 117.644 174.982 97.4061 149.315 121.365C122.855 146.064 127.265 196.937 67.2227 199.982Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.467 208.914H115.947V221.036H126.467V208.914Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.467 211.463H115.947V215.262H126.467V211.463Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.886 152H84.5182C82.3255 152 80.548 153.778 80.548 155.97V207.391C80.548 209.584 82.3255 211.361 84.5182 211.361H157.886C160.078 211.361 161.856 209.584 161.856 207.391V155.97C161.856 153.778 160.078 152 157.886 152Z",
    fill: "url(#paint0_linear_10512_2972)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5481 204.176V207.531C80.5481 209.829 82.3216 211.693 84.5183 211.693H157.886C160.083 211.693 161.856 209.829 161.856 207.531V204.176H80.5481Z",
    fill: "url(#paint1_linear_10512_2972)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.397 153.225H86.1867C84.0877 153.225 82.3861 154.939 82.3861 157.054V198.41C82.3861 200.525 84.0877 202.24 86.1867 202.24H156.397C158.496 202.24 160.197 200.525 160.197 198.41V157.054C160.197 154.939 158.496 153.225 156.397 153.225Z",
    fill: "url(#paint2_linear_10512_2972)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3861 158.739C82.3861 155.693 84.8549 153.225 87.9003 153.225H154.683C157.729 153.225 160.197 155.693 160.197 158.739H82.3861Z",
    fill: "url(#paint3_linear_10512_2972)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2241,
    y: 161.803,
    width: 7.35225,
    height: 2.45075,
    fill: "#DDC8BA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1891,
    y: 161.803,
    width: 7.35225,
    height: 2.45075,
    fill: "#DDC8BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.493,
    y: 161.803,
    width: 4.28881,
    height: 1.83806,
    rx: 0.919031,
    fill: "#FFB183"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 151.007,
    y: 161.803,
    width: 7.35225,
    height: 1.83806,
    rx: 0.919031,
    fill: "#D4F7E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2241,
    y: 165.479,
    width: 23.8948,
    height: 4.28881,
    rx: 2,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2241,
    y: 170.992,
    width: 23.8948,
    height: 13.4791,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0622,
    y: 173.443,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint4_linear_10512_2972)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0622,
    y: 178.957,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2241,
    y: 185.697,
    width: 23.8948,
    height: 14.7045,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.957,
    y: 185.697,
    width: 23.8948,
    height: 14.7045,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 135.077,
    y: 185.697,
    width: 23.8948,
    height: 14.7045,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 109.957,
    y: 165.479,
    width: 23.8948,
    height: 4.28881,
    rx: 2,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 135.619,
    y: 165.479,
    width: 23.8948,
    height: 4.28881,
    rx: 2,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 87.2877,
    y: 188.148,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint5_linear_10512_2972)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 87.2877,
    y: 193.662,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint6_linear_10512_2972)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0272,
    y: 188.148,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint7_linear_10512_2972)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0272,
    y: 193.662,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint8_linear_10512_2972)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100.767,
    y: 188.148,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint9_linear_10512_2972)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 100.767,
    y: 193.662,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint10_linear_10512_2972)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 113.02,
    y: 188.148,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint11_linear_10512_2972)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 113.021,
    y: 193.662,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint12_linear_10512_2972)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 119.76,
    y: 188.148,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint13_linear_10512_2972)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 119.76,
    y: 193.662,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint14_linear_10512_2972)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: 188.148,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint15_linear_10512_2972)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: 193.662,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint16_linear_10512_2972)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 138.141,
    y: 188.762,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint17_linear_10512_2972)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 138.141,
    y: 194.277,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint18_linear_10512_2972)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 144.88,
    y: 188.762,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint19_linear_10512_2972)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 144.88,
    y: 194.277,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint20_linear_10512_2972)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 151.62,
    y: 188.762,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint21_linear_10512_2972)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 151.62,
    y: 194.277,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint22_linear_10512_2972)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 109.957,
    y: 170.994,
    width: 23.8948,
    height: 14.0918,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 111.795,
    y: 172.832,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint23_linear_10512_2972)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 111.795,
    y: 177.121,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 111.795,
    y: 179.57,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 111.795,
    y: 182.023,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 135.619,
    y: 170.994,
    width: 23.8948,
    height: 14.0918,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 137.457,
    y: 172.832,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint24_linear_10512_2972)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 137.457,
    y: 177.121,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 137.457,
    y: 179.57,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 137.457,
    y: 182.023,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147.331,
    cy: 156.288,
    r: 1.22537,
    fill: "url(#paint25_linear_10512_2972)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.394,
    cy: 156.288,
    r: 1.22537,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.458,
    cy: 156.288,
    r: 1.22537,
    fill: "url(#paint26_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.972 154.405C158.281 153.68 157.298 153.225 156.22 153.225H86.1746C84.0815 153.225 82.3861 154.902 82.3861 156.974V197.5C82.3861 198.36 82.6791 199.157 83.171 199.789L158.972 154.405Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.662 219.301H133.742C134.78 219.301 135.627 220.147 135.627 221.185V223.835H106.787V221.185C106.787 220.147 107.634 219.301 108.672 219.301H108.662Z",
    fill: "url(#paint27_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.742 219.301H121.308C122.346 219.301 123.192 220.147 123.192 221.185V223.835H135.627V221.185C135.627 220.147 134.78 219.301 133.742 219.301Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.008 220.529C116.008 221.144 112.602 221.285 110.163 221.285C108.007 221.285 107.664 220.952 107.664 220.529C107.664 220.106 108.148 219.773 110.163 219.773C112.592 219.773 116.008 219.904 116.008 220.529Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.617 220.529C118.617 220.781 118.134 220.952 117.61 220.952C117.086 220.952 116.713 220.76 116.713 220.529C116.713 220.297 117.086 220.105 117.61 220.105C118.134 220.105 118.617 220.277 118.617 220.529Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.617 222.988H106.777V223.825H135.617V222.988Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.856 204.176H80.5481V205.264H161.856V204.176Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.16 208.116C157.16 208.973 156.465 209.668 155.608 209.668C154.752 209.668 154.057 208.973 154.057 208.116C154.057 207.26 154.752 206.564 155.608 206.564C156.465 206.564 157.16 207.26 157.16 208.116Z",
    fill: "#463332"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M155.608 209.145C156.176 209.145 156.636 208.685 156.636 208.118C156.636 207.55 156.176 207.09 155.608 207.09C155.041 207.09 154.581 207.55 154.581 208.118C154.581 208.685 155.041 209.145 155.608 209.145Z",
    fill: "url(#paint28_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10512_2972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 152,
    width: 76,
    height: 72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.704 152.541H191.72C193.753 152.541 195.401 154.189 195.401 156.223V219.826C195.401 221.86 193.753 223.508 191.72 223.508H123.704C121.67 223.508 120.022 221.86 120.022 219.826V156.223C120.022 154.189 121.67 152.541 123.704 152.541Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10512_2972)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.625 186.982C182.379 190.197 189.46 203.005 190.629 210.388C191.797 217.771 186.898 226.839 186.898 226.839H177.869C177.869 226.839 180.353 216.544 180.645 212.677C180.937 208.81 174.372 202.07 174.372 202.07L177.625 186.982Z",
    fill: "url(#paint29_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178.522 224.053C178.609 223.663 178.707 223.244 178.804 222.806C178.814 222.757 178.823 222.709 178.833 222.66C179.028 221.774 179.242 220.8 179.447 219.816C179.476 219.699 179.496 219.572 179.525 219.455C179.603 219.095 179.671 218.735 179.739 218.374C179.768 218.228 179.797 218.082 179.827 217.936C179.914 217.478 180.002 217.02 180.08 216.582C180.08 216.563 180.08 216.553 180.08 216.533C180.158 216.085 180.236 215.647 180.304 215.228C180.323 215.111 180.343 214.994 180.362 214.878C180.411 214.576 180.45 214.283 180.489 214.001C180.509 213.894 180.518 213.777 180.538 213.67C180.586 213.309 180.625 212.968 180.645 212.676C180.664 212.404 180.645 212.111 180.596 211.809C180.586 211.731 180.567 211.644 180.557 211.566C180.509 211.313 180.44 211.05 180.353 210.777C180.333 210.728 180.323 210.679 180.304 210.621C180.197 210.309 180.06 209.978 179.914 209.657C179.875 209.569 179.827 209.481 179.788 209.394C179.661 209.131 179.525 208.868 179.379 208.605C179.34 208.527 179.291 208.449 179.252 208.371C179.067 208.05 178.862 207.718 178.658 207.397C178.609 207.319 178.56 207.251 178.512 207.173C177.82 206.131 177.06 205.147 176.388 204.319L178.541 205.215L179.612 200.121C179.875 205.215 184.336 213.972 187.94 213.884C191.359 213.796 190.707 210.865 190.658 210.436C191.788 217.809 186.918 226.819 186.918 226.819H177.888C177.888 226.819 178.161 225.679 178.531 224.033L178.522 224.053Z",
    fill: "#463332"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.717 180.66C131.554 180.378 133.171 181.41 133.152 181.391C133.015 182.706 132.762 183.826 132.187 184.381C131.778 184.03 132.031 182.891 131.749 182.696C131.457 182.491 131.242 182.423 131.048 182.491C130.882 182.55 130.405 183.027 129.937 183.582C129.801 183.748 129.655 185.628 128.866 185.355C128.554 185.248 128.447 183.173 128.807 182.696C129.479 181.771 130.307 180.787 130.726 180.651L130.717 180.66Z",
    fill: "url(#paint30_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.717 180.66C131.554 180.378 133.171 181.41 133.152 181.391C133.015 182.706 132.762 183.826 132.187 184.381C131.778 184.03 132.031 182.891 131.749 182.696C131.457 182.491 131.242 182.423 131.048 182.491C130.882 182.55 130.405 183.027 129.937 183.582C129.801 183.748 129.655 185.628 128.866 185.355C128.554 185.248 128.447 183.173 128.807 182.696C129.479 181.771 130.307 180.787 130.726 180.651L130.717 180.66Z",
    fill: "#C3694D"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133.707 204.173C132.782 200.764 132.09 188.754 132.09 188.754L135.499 187.381C135.499 187.381 138.334 196.683 139.824 202.761C139.824 202.761 134.642 207.592 133.717 204.183L133.707 204.173Z",
    fill: "url(#paint31_linear_10512_2972)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.499 187.381C135.07 185.54 134.759 181.858 134.262 178.313C133.911 175.829 133.21 174.173 132.908 174.3C132.294 174.563 132.528 175.848 132.82 178.274C132.918 179.063 132.947 180.154 132.957 180.67C132.957 180.67 131.467 179.667 130.668 179.939C130.191 180.095 129.168 181.303 128.515 182.345C128.301 182.881 127.902 184.274 128.135 184.449C128.652 184.829 129.343 183.543 129.548 183.212C130.191 182.598 130.804 181.848 130.999 181.78C131.379 181.644 132.343 182.404 132.421 182.706C132.519 183.056 132.324 183.514 131.963 184.04C131.291 185.024 130.103 185.949 129.996 186.358C130.463 187.449 132.002 188.628 132.324 188.978C133.678 189.193 135.499 187.381 135.499 187.381Z",
    fill: "url(#paint32_linear_10512_2972)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M130.346 186.972C129.889 186.29 129.411 185.287 128.837 184.245C128.204 183.115 127.522 182.248 127.639 181.868C127.863 181.128 129.129 181.946 130.044 183.144C131.009 184.41 131.876 184.079 131.876 184.079C131.876 184.079 132.265 185.706 131.837 186.68C131.408 187.654 130.356 186.972 130.356 186.972H130.346Z",
    fill: "url(#paint33_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M130.347 186.972C130.347 186.963 130.327 186.953 130.327 186.933C130.239 186.807 130.152 186.68 130.084 186.544C129.704 185.901 129.304 185.083 128.837 184.245C128.837 184.245 128.837 184.235 128.837 184.226L128.243 183.222C127.863 182.599 127.571 182.122 127.658 181.868C127.707 181.722 127.785 181.644 127.902 181.605C127.931 182.18 128.915 183.32 129.548 184.372C130.308 185.628 131.389 187.537 133.21 188.56L134.038 192.709L132.392 192.777C132.226 190.44 132.129 188.755 132.129 188.755C131.7 188.375 130.902 187.693 130.386 186.972H130.347Z",
    fill: "#C3694D"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M153.557 186.885C150.217 188.823 142.142 203.248 142.142 203.248L136.785 189.096L130.872 192.602C130.872 192.602 131.885 214.985 141.791 215.794C149.35 216.407 154.454 204.018 154.454 204.018L153.557 186.895V186.885Z",
    fill: "url(#paint34_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.236 191.783C132.762 197.559 135.285 213.679 142.551 213.796C148.999 213.903 151.337 202.137 151.337 202.137L153.645 205.712C151.941 209.082 147.596 216.26 141.791 215.793C131.876 214.984 130.873 192.601 130.873 192.601L132.236 191.793V191.783Z",
    fill: "#463332"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M170.203 182.433C169.726 181.605 163.171 181.283 161.564 183.036C159.957 184.79 164.71 186.251 164.71 186.251C164.71 186.251 171.168 184.088 170.203 182.433Z",
    fill: "#EDD3BE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M160.171 184.391C160.171 184.391 155.515 185.472 153.811 186.709C152.009 188.014 151.142 192.923 151.132 199.537C151.113 208.118 152.301 219.329 151.629 226.829H178.999C178.999 226.829 178.57 214.059 179.369 203.54C180.294 191.287 179.106 188.813 178.064 187.391C177.022 185.968 171.294 184.917 171.294 184.917L160.171 184.371V184.391Z",
    fill: "url(#paint35_linear_10512_2972)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M169.395 179.005C169.395 179.005 173.174 176.998 173.797 170.833C174.392 164.92 173.418 163.518 171.362 162.446C169.823 161.638 166.064 164.462 166.064 164.462L169.395 179.014V179.005Z",
    fill: "url(#paint36_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.414 165.7C166.414 165.7 169.103 167.55 172.035 166.43C173.35 165.924 173.32 164.755 172.931 163.635C173.866 164.794 174.216 166.722 173.798 170.823C173.174 176.989 169.395 178.995 169.395 178.995L166.414 165.972V165.69V165.7Z",
    fill: "#491D17"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M170.632 175.461C170.632 175.461 168.869 180.896 170.135 184.636C170.418 185.571 163.882 185.338 161.398 184.247C161.398 184.247 162.051 183.721 162.148 181.013C162.197 179.776 170.622 175.461 170.622 175.461H170.632Z",
    fill: "url(#paint37_linear_10512_2972)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.496 184.148C161.496 184.148 161.213 184.226 160.531 184.334C160.531 184.334 160.531 187.09 164.427 187.45C169.112 187.889 171.362 184.986 171.362 184.986L169.522 184.528L161.496 184.148Z",
    fill: "url(#paint38_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M167.963 187.1C164.603 185.902 162.626 184.052 161.876 183.224C162.002 182.737 162.119 182.026 162.158 181.013C162.207 179.776 170.632 175.461 170.632 175.461C170.632 175.461 168.869 180.896 170.135 184.636L171.362 184.987C171.362 184.987 170.252 186.36 167.953 187.091L167.963 187.1Z",
    fill: "#AC6B53"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M170.651 171.534C172.132 171.232 172.921 173.131 172.453 174.31C171.976 175.528 170.613 176.229 169.541 176.053C169.035 175.381 169.687 171.972 170.651 171.534Z",
    fill: "url(#paint39_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M170.749 172.731C171.548 172.634 171.898 173.647 171.616 174.241C171.324 174.855 170.583 175.166 170.018 175.03C169.921 174.903 170.398 172.848 170.749 172.731Z",
    fill: "#E48665"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M170.651 171.534C172.132 171.232 172.921 173.131 172.453 174.31C171.976 175.528 170.613 176.229 169.541 176.053C169.035 175.381 169.687 171.972 170.651 171.534Z",
    fill: "#E48665"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M169.853 170.405C169.736 167.755 168.713 164.999 164.613 164.035C160.044 162.963 157.142 165.028 156.587 168.038C156.402 169.022 156.421 171.272 156.967 175.041C157.492 178.655 158.622 182.999 162.499 183.272C164.096 183.379 168.606 182.58 169.502 176.21C169.502 176.21 170.048 174.72 169.863 170.405H169.853Z",
    fill: "url(#paint40_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M167.71 176.483C168.197 170.746 166.921 166.061 166.921 166.061L169.171 167.356C169.629 168.311 169.814 169.372 169.853 170.405C170.048 174.71 169.492 176.21 169.492 176.21C168.586 182.58 164.087 183.388 162.489 183.272C164.622 182.94 167.311 181.187 167.71 176.483Z",
    fill: "#E48665"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M164.544 164.386C169.492 166.392 168.061 173.678 169.21 173.775C169.872 173.834 170.379 172.119 170.369 170.736C170.359 168.905 169.999 166.1 168.528 164.834C167.944 164.327 165.138 164.142 164.544 164.386Z",
    fill: "url(#paint41_linear_10512_2972)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M167.7 167.57C167.7 167.57 166.171 163.372 160.658 164.21C156.246 164.872 156.509 169.557 156.509 169.557C154.746 168.534 153.927 163.216 155.797 160.879C157.853 158.317 156.625 162.486 160.707 160.392C165.674 157.859 171.119 159.096 171.82 162.914L167.7 167.57Z",
    fill: "url(#paint42_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M169.755 166.781C170.223 168.096 170.359 169.518 170.369 170.735C170.379 172.118 169.872 173.823 169.21 173.774C168.255 173.696 169.093 168.631 166.531 165.777C166.892 165.992 167.895 166.781 169.755 166.79V166.781Z",
    fill: "#491D17"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M165.655 185.668L164.593 187.49L163.833 185.571L161.622 186.526L160.229 184.363L158.554 184.811C159.353 189.311 161.009 194.883 163.892 197.678C169.239 193.772 171.587 188.873 172.979 185.318C172.473 185.162 171.927 185.045 171.353 184.948L165.655 185.678V185.668Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.655 184.957C171.655 184.957 171.148 188.152 166.561 190.217L165.567 185.668L171.655 184.957Z",
    fill: "#ECD2BD"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M163.852 189.33L165.45 189.379L166.258 196.879C165.499 197.58 164.68 198.252 163.784 198.914C163.278 198.427 162.81 197.863 162.372 197.239L163.852 189.34V189.33Z",
    fill: "url(#paint43_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 198.357C162.957 198.007 162.655 197.637 162.372 197.237L163.853 189.338L165.45 189.387L165.547 190.312C164.525 190.702 163.434 194.101 163.268 198.367V198.357Z",
    fill: "#822E50"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.989 185.92C166.989 185.92 166.005 187.264 164.69 187.167C163.376 187.069 162.528 185.969 162.528 185.969L161.963 187.001C161.963 187.001 162.859 188.384 164.544 188.433C166.239 188.482 167.457 187.05 167.457 187.05L166.989 185.92Z",
    fill: "url(#paint44_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M166.989 185.92C166.989 185.92 166.005 187.264 164.69 187.167C163.376 187.069 162.528 185.969 162.528 185.969L161.963 187.001C161.963 187.001 162.859 188.384 164.544 188.433C166.239 188.482 167.457 187.05 167.457 187.05L166.989 185.92Z",
    fill: "#822E50"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M165.976 186.863C165.703 186.571 163.677 186.552 163.444 186.863C163.2 187.175 163.638 189.201 163.775 189.347C163.911 189.493 165.372 189.522 165.528 189.396C165.684 189.259 166.249 187.165 165.976 186.873V186.863Z",
    fill: "url(#paint45_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M163.443 186.865C163.531 186.748 163.862 186.68 164.262 186.65C164.116 186.855 164.018 187.098 164.018 187.371C164.018 188.072 164.564 188.628 165.245 188.628C165.469 188.628 165.674 188.55 165.859 188.433C165.742 188.91 165.606 189.319 165.538 189.378C165.382 189.514 163.93 189.475 163.784 189.329C163.638 189.183 163.21 187.157 163.453 186.845L163.443 186.865Z",
    fill: "#822E50"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M163.862 185.647L162.879 190.206C162.879 190.206 159.723 187.975 160.132 184.488L163.862 185.647Z",
    fill: "#ECD2BD"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M170.203 182.434C170.203 182.434 168.84 184.869 165.645 185.677L166.726 189.252C168.947 188.453 171.002 186.534 171.655 184.966L170.203 182.443V182.434Z",
    fill: "#FFE6D6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M163.823 185.57L162.801 189.242C162.801 189.242 159.927 186.222 160.151 184.284L161.515 183.105C161.515 183.105 162.012 184.615 163.814 185.57H163.823Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M155.798 160.878C156.363 160.177 156.674 159.992 156.918 160.031C155.768 160.547 155.155 163.499 156.343 163.8C157.395 164.063 157.619 162.875 159.635 162.437C162.947 161.716 166.093 165.515 169.132 164.015C171.207 162.992 170.671 161.073 169.619 159.943C170.778 160.596 171.596 161.599 171.84 162.924C171.178 164.278 169.716 165.32 166.278 165.602C165.207 164.648 163.444 163.8 160.668 164.219C156.255 164.882 156.518 169.567 156.518 169.567C154.756 168.544 153.937 163.226 155.807 160.888L155.798 160.878Z",
    fill: "#491D17"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M163.512 174.962C164.164 174.962 164.778 174.709 165.245 174.241C165.713 173.783 165.966 173.16 165.966 172.507C165.966 171.855 165.713 171.241 165.245 170.774C164.788 170.306 164.174 170.053 163.512 170.053C162.158 170.053 161.067 171.153 161.057 172.498C161.057 173.15 161.31 173.764 161.778 174.231C162.236 174.699 162.859 174.952 163.512 174.952V174.962ZM163.512 170.433C164.067 170.433 164.583 170.647 164.982 171.046C165.372 171.436 165.586 171.962 165.586 172.517C165.586 173.072 165.372 173.588 164.973 173.988C164.583 174.377 164.057 174.592 163.512 174.592C162.956 174.592 162.44 174.377 162.041 173.978C161.651 173.588 161.437 173.062 161.437 172.507C161.437 171.358 162.372 170.433 163.512 170.433Z",
    fill: "#423333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M157.775 175.596C157.862 175.596 157.96 175.596 158.057 175.577C159.129 175.401 159.82 174.213 159.616 172.937C159.401 171.661 158.369 170.765 157.288 170.95C156.216 171.125 155.525 172.314 155.729 173.59C155.827 174.203 156.129 174.749 156.557 175.119C156.918 175.43 157.346 175.596 157.775 175.596ZM157.561 171.301C158.349 171.301 159.08 172.021 159.246 172.995C159.421 174.067 158.866 175.06 157.999 175.206C157.59 175.275 157.161 175.138 156.811 174.836C156.45 174.515 156.197 174.057 156.109 173.531C155.934 172.46 156.489 171.466 157.356 171.32C157.424 171.31 157.502 171.301 157.57 171.301H157.561Z",
    fill: "#423333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M165.762 172.458C165.762 172.458 165.771 172.458 165.781 172.458L170.34 171.932C170.437 171.922 170.505 171.834 170.495 171.727C170.486 171.63 170.398 171.561 170.291 171.571L165.733 172.097C165.635 172.107 165.567 172.195 165.577 172.302C165.586 172.389 165.664 172.458 165.752 172.458H165.762Z",
    fill: "#423333"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M159.547 173.315C159.596 173.315 159.645 173.295 159.684 173.247C160.317 172.438 161.155 172.974 161.184 172.993C161.262 173.042 161.369 173.023 161.418 172.945C161.466 172.867 161.447 172.76 161.369 172.711C160.979 172.458 160.073 172.204 159.411 173.042C159.353 173.12 159.362 173.217 159.44 173.276C159.469 173.295 159.508 173.315 159.547 173.315Z",
    fill: "#423333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M164.242 198.671L161.164 199.665C159.158 198.301 156.879 196.012 156.703 195.262C156.499 194.385 157.512 193.032 157.512 193.032C157.512 193.032 155.69 192.963 155.145 192.087C154.765 191.463 154.94 188.006 155.087 186.028C156.07 185.59 157.259 185.2 158.242 184.918C159.411 190.898 161.281 195.584 164.233 198.681L164.242 198.671Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M151.151 201.817C154.492 204.992 159.849 205.947 165.752 205.528C171.694 205.099 176.768 203.375 179.612 199.713C179.554 200.872 179.486 202.138 179.379 203.551C178.58 214.07 179.008 226.839 179.008 226.839H151.638C152.252 219.973 151.298 210.028 151.161 201.817H151.151Z",
    fill: "#463332"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M136.424 189.282L131.243 192.408L131.106 190.509L135.957 187.938L136.424 189.282Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M161.233 200.541C161.145 200.054 161.096 199.752 161.096 199.752L161.34 199.576C165.236 198.768 172.843 191.385 173.437 185.404C174.265 185.609 175.21 185.882 176.048 186.203C176.106 187.44 176.174 191.872 174.216 194.102L171.596 194.287C171.596 194.287 172.59 196.196 172.336 196.693C172.083 197.19 166.249 201.076 161.233 200.531V200.541Z",
    fill: "#463332"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.999 185.092L175.346 185.803C175.346 185.803 175.804 191.16 173.622 193.644L171.09 193.955C171.09 193.955 172.083 195.64 171.84 196.118C171.596 196.595 165.908 200.384 161.096 199.761L163.911 197.705C168.187 194.267 171.324 190.147 172.989 185.092H172.999Z",
    fill: "#665050"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M158.486 184.596L156.07 185.55C156.07 185.55 155.564 191.229 156.031 191.998C156.499 192.758 158.087 192.816 158.087 192.816C158.087 192.816 157.21 193.985 157.385 194.755C157.561 195.514 160.229 198.096 162.1 199.089L163.921 197.716C161.164 194.833 159.489 190.362 158.496 184.605L158.486 184.596Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M163.901 197.706L161.096 199.761C161.096 199.761 162.304 210.426 162.333 216.67C162.363 222.913 162.08 226.78 162.08 226.78H161.466C161.466 226.78 161.817 220.011 161.807 216.758C161.807 213.504 160.522 199.293 160.522 199.293L163.473 197.219L163.901 197.706Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M166.726 213.552C166.08 213.552 165.557 213.029 165.557 212.384C165.557 211.738 166.08 211.215 166.726 211.215C167.371 211.215 167.895 211.738 167.895 212.384C167.895 213.029 167.371 213.552 166.726 213.552Z",
    fill: "#463332"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M165.879 212.228C165.879 212.783 166.327 213.241 166.892 213.241C167.457 213.241 167.905 212.793 167.905 212.228C167.905 211.663 167.457 211.215 166.892 211.215C166.327 211.215 165.879 211.663 165.879 212.228Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M166.872 221.199C166.227 221.199 165.703 220.676 165.703 220.03C165.703 219.385 166.227 218.861 166.872 218.861C167.518 218.861 168.041 219.385 168.041 220.03C168.041 220.676 167.518 221.199 166.872 221.199Z",
    fill: "#463332"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M166.015 219.874C166.015 220.43 166.463 220.887 167.028 220.887C167.593 220.887 168.041 220.439 168.041 219.874C168.041 219.309 167.593 218.861 167.028 218.861C166.463 218.861 166.015 219.309 166.015 219.874Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M177.012 206.549L169.132 206.569L169.103 201.543L176.982 201.523L177.012 206.549Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M176.369 205.899L169.064 205.928L169.044 201.574L176.34 201.555L176.369 205.899Z",
    fill: "#FFE6D6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M173.817 200.512L171.557 200.521L171.567 201.564L173.817 201.554V200.512Z",
    fill: "#847070"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M175.892 205.294H173.388L173.369 202.139L175.872 202.129L175.892 205.294Z",
    fill: "#DDC4B6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M172.96 203.93L169.551 203.94V203.238L172.96 203.229V203.93Z",
    fill: "#DDC4B6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M172.96 202.811L169.551 202.82L169.541 202.148L172.95 202.139L172.96 202.811Z",
    fill: "#DDC4B6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M172.97 204.681L169.56 204.69L169.551 204.33L172.96 204.32L172.97 204.681Z",
    fill: "#DDC4B6"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4842 245.751H70.2233C57.7543 239.343 55.0485 196.635 71.4259 192.869C87.8033 189.103 90.2401 211.525 95.6359 213.693C100.051 215.465 105.51 215.607 107.013 221.098C108.516 226.605 107.757 240.023 98.4684 245.751H98.4842Z",
    fill: "url(#paint46_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M71.505 192.867C71.505 192.867 71.5525 192.867 71.5841 192.852C66.9162 197.773 64.0046 204.767 64.0046 212.52C64.0046 227.394 74.7172 239.452 87.9299 239.452C96.1265 239.452 103.374 234.816 107.678 227.727C107.393 233.93 105.083 241.731 98.5633 245.75H70.3024C57.8334 239.341 55.0169 196.76 71.505 192.867Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1509 194.498C88.9584 194.498 90.8098 211.746 95.6518 213.692C98.0569 214.657 100.779 215.132 102.994 216.255C102.962 216.793 102.867 217.221 102.677 217.521C99.8292 222.173 100.13 225.939 100.13 225.939H77.2489C71.9481 225.939 68.451 218.471 68.546 210.812C68.6409 202.758 71.7423 194.498 78.1667 194.498H78.1509Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M106.08 235.767C105.383 237.745 104.434 239.659 103.168 241.384C98.4685 233.979 98.0887 225.845 98.0887 225.845L101.269 225.244L106.08 235.767Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7374 245.577C98.6582 245.624 98.5791 245.703 98.5 245.751H92.8352C90.7148 236.557 91.6642 225.734 91.6642 225.734L95.1612 225.133L98.7216 245.577H98.7374Z",
    fill: "#AA2424"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1918 183.594C75.1918 188.009 73.0872 191.68 73.9892 195.446C74.638 198.168 77.7394 198.595 77.7394 198.595C77.7394 198.595 89.7495 199.798 90.4299 194.766C91.1103 189.734 87.8981 187.408 87.5975 183.357C87.2968 179.306 75.1918 181.142 75.1918 183.61V183.594Z",
    fill: "url(#paint47_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1918 183.594C75.1918 188.009 73.0872 191.68 73.9892 195.446C74.638 198.168 77.7394 198.595 77.7394 198.595C77.7394 198.595 89.7495 199.798 90.4299 194.766C91.1103 189.734 87.8981 187.408 87.5975 183.357C87.2968 179.306 75.1918 181.142 75.1918 183.61V183.594Z",
    fill: "#491D17"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M101.744 217.362C100.684 217.014 91.9015 215.748 91.9015 215.748L89.6862 216.777L91.4268 225.97H100.858L101.744 217.378V217.362Z",
    fill: "url(#paint48_linear_10512_2972)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M106.079 223.201C108.168 231.177 111.839 243.503 111.839 243.503C110.7 243.883 109.513 244.089 108.184 243.503C108.184 243.503 104.734 237.68 101.475 229.341C100.019 225.638 97.7404 219.831 99.9715 217.79C101.506 216.381 104.687 217.916 106.079 223.201Z",
    fill: "url(#paint49_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7337 217.046L89.9553 216.634L91.8857 215.748C91.8857 215.748 99.9557 216.903 101.554 217.315C102.741 217.473 104.117 218.565 105.162 220.717C104.608 220.084 103.722 219.039 102.582 219.419C100.367 220.163 101.253 227.157 103.516 232.458C105.51 237.157 109.545 242.648 110.447 243.835C109.735 243.93 108.975 243.867 108.184 243.503C108.184 243.503 104.734 237.68 101.475 229.34C101.079 228.328 100.62 227.173 100.209 225.954H92.5187L90.8256 222.837L89.7179 217.046H89.7337Z",
    fill: "#334B72"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9546 216.286H87.3444L87.3128 215.922C87.3128 215.922 94.3701 216.887 95.3986 217.615L91.9016 225.954H77.2174C74.5115 223.881 74.021 219.261 74.9388 216.286H74.9546Z",
    fill: "url(#paint50_linear_10512_2972)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1676 223.281C98.6897 232.553 100.019 243.503 100.019 243.503C98.8638 244.025 97.4871 244.104 96.3637 243.503C96.3637 243.503 93.737 237.68 92.2337 229.294C91.49 225.132 90.4298 220.1 92.835 218.011C94.7655 216.334 97.8669 217.758 98.1676 223.281Z",
    fill: "url(#paint51_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9543 216.286H87.3442L87.3125 215.922C87.3125 215.922 93.1514 216.729 94.987 217.409C96.506 217.742 97.9618 219.593 98.1675 223.28C98.215 224.134 98.2625 225.005 98.3257 225.891V225.938C97.946 222.41 97.946 219.213 94.4806 219.102C89.6703 218.96 83.7364 220.052 83.7364 222.014C83.7364 223.976 92.1546 223.691 93.0565 224.435C93.9426 225.179 92.4235 234.942 98.12 243.914C97.5187 243.914 96.9174 243.787 96.3636 243.502C96.3636 243.502 93.7369 237.679 92.2337 229.293C92.0438 228.217 91.8222 227.077 91.664 225.954H77.2487C74.5429 223.881 74.0524 219.261 74.9701 216.286H74.9543Z",
    fill: "#334B72"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3416 203.201C99.1012 201.603 100.114 196.302 100.351 195.51C100.636 194.498 98.5632 194.735 98.5632 194.735C98.4208 195.526 96.7435 199.118 95.4776 201.966C95.4776 201.966 97.5979 204.799 98.3575 203.201H98.3416Z",
    fill: "url(#paint52_linear_10512_2972)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5474 194.734C98.8164 193.484 99.6867 191.427 100.541 191.364C101.047 191.332 101.712 192.994 101.538 193.437C101.19 194.354 100.573 194.972 100.383 195.43C100.193 195.905 98.5474 194.734 98.5474 194.734Z",
    fill: "url(#paint53_linear_10512_2972)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M82.882 193.628C85.936 200.812 89.8286 209.357 93.8003 209.99C96.4112 210.401 99.6234 208.613 100.351 197.584L97.3606 195.194L94.0376 203.977C92.7401 203.818 91.5375 195.891 89.069 193.391C87.9772 192.283 82.882 193.628 82.882 193.628Z",
    fill: "url(#paint54_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M87.455 195.193C89.3222 204.703 92.7876 207.979 94.2117 208.026C96.7277 208.106 99.1328 206.397 100.351 197.583C99.6234 208.612 96.4112 210.4 93.8003 209.989C89.8286 209.356 85.936 200.811 82.882 193.627C82.882 193.627 87.0753 195.288 87.455 195.193Z",
    fill: "#A0335D"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1924 174.291C85.1924 174.291 86.395 173.515 87.8982 174.686C89.9553 176.285 89.0059 178.706 89.2907 180.414L85.8887 176.728L85.1924 174.275V174.291Z",
    fill: "url(#paint55_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8887 176.744L89.2907 180.43C89.085 179.244 89.4806 177.709 89.0692 176.364C88.816 176.554 88.4521 176.538 87.74 176.063C86.9963 175.557 86.3792 174.766 86.3792 174.766L85.6355 175.857L85.8887 176.759V176.744Z",
    fill: "#491D17"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8121 216.713C76.5844 211.365 79.6383 210.02 79.3851 206.301C79.1952 203.548 75.4134 200.067 76.6318 195.098C77.5654 191.317 81.1732 191.427 84.3379 191.332C85.6038 191.301 86.8855 191.601 87.9457 192.298C90.3034 193.864 92.1864 198.785 91.5851 200.921C90.968 203.121 89.5438 203.247 89.5438 206.523C89.5438 209.26 90.8888 211.935 91.9016 215.859C92.0756 217.346 80.5402 219.91 74.8121 216.713Z",
    fill: "url(#paint56_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3853 206.301C79.1954 203.548 75.4136 200.067 76.632 195.098C76.8377 194.291 77.1542 193.674 77.5656 193.184C77.3599 194.972 77.7238 196.87 78.7207 198.564C81.5215 203.279 89.8447 204.972 91.6644 200.32C91.6486 200.542 91.6169 200.747 91.5695 200.937C90.9523 203.137 89.5282 203.263 89.5282 206.539C89.5282 209.276 90.8732 211.95 91.8859 215.875C92.06 217.362 80.5246 219.925 74.7965 216.729C76.5687 211.381 79.6227 210.036 79.3695 206.317L79.3853 206.301Z",
    fill: "#A0335D"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5084 191.617L79.8597 191.776C80.461 193.485 82.7237 196.222 85.6986 195.842C88.1196 195.542 87.6765 193.216 86.9803 191.776L86.1733 191.443L80.5084 191.602V191.617Z",
    fill: "url(#paint57_linear_10512_2972)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9199 184.117C81.2522 185.51 81.363 186.665 81.4737 188.295C81.632 190.589 80.4294 191.712 80.4294 191.712C81.901 192.092 84.6068 192.251 86.1891 191.459C86.1891 191.459 84.9707 191.159 85.4455 188.026C85.7619 185.874 80.9357 184.117 80.9357 184.117H80.9199Z",
    fill: "url(#paint58_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9929 195.336C81.8536 194.75 80.9516 193.769 80.3978 192.852C80.2079 192.535 80.0655 192.25 79.9547 191.981C79.9547 191.981 79.9073 191.855 79.8756 191.791L80.5244 191.633C80.5244 191.633 80.6668 191.459 80.7617 191.332C80.7617 191.332 80.7617 191.332 80.7617 191.317C81.0782 190.826 81.5213 189.924 81.4738 188.579C81.4738 188.5 81.4738 188.405 81.4738 188.326C81.4738 188.247 81.4738 188.184 81.4738 188.12C81.3947 187.092 81.3156 186.237 81.1732 185.383L85.3664 187.377C85.4455 187.598 85.4772 187.835 85.4455 188.057C84.9866 191.206 86.1892 191.491 86.1892 191.491L86.3633 191.57C85.9202 192.361 84.7651 194.197 82.9929 195.367V195.336Z",
    fill: "#AC6B53"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1255 186.935C83.0718 189.704 86.6479 190.1 87.1701 189.941C87.6923 189.783 90.6988 186.27 89.4962 182.362C89.3538 181.84 89.2272 179.165 88.5468 178.042C86.8695 175.273 84.5276 175.241 82.2965 176.032C78.7836 177.282 78.6729 180.479 79.8438 183.96C79.8438 183.96 80.2869 185.748 81.1255 186.935Z",
    fill: "url(#paint59_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9516 181.428L79.6066 183.137C79.6857 183.406 79.749 183.691 79.8439 183.975C79.8439 183.975 80.287 185.763 81.1256 186.95C83.0719 189.719 86.648 190.115 87.1702 189.957C81.1573 189.292 80.9516 181.428 80.9516 181.428Z",
    fill: "#E38565"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6542 183.057C78.594 182.93 78.1034 184.291 78.4832 185.082C78.8788 185.905 79.9548 186.317 80.6985 186.143C81.0308 185.652 80.3504 183.31 79.6542 183.057Z",
    fill: "url(#paint60_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6542 183.057C78.594 182.93 78.1035 184.291 78.4832 185.082C78.8788 185.905 79.9548 186.333 80.6986 186.158C81.0308 185.668 80.3504 183.31 79.6384 183.057H79.6542Z",
    fill: "#E38565"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6225 183.896C79.0528 183.864 78.8471 184.592 79.0686 184.987C79.306 185.399 79.844 185.573 80.2396 185.462C80.3029 185.367 79.9706 184.877 79.6225 183.896Z",
    fill: "#AC6B53"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7774 182.631C80.7457 183.454 80.9514 184.166 80.3343 184.308C79.7172 184.435 79.3532 183.042 79.3532 183.042L80.7774 182.647V182.631Z",
    fill: "url(#paint61_linear_10512_2972)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6956 175.604C86.838 177.456 84.0531 178.437 82.6922 179.37C80.5877 180.81 80.7776 183.231 80.7776 183.231L79.4326 183.01C79.4326 183.01 76.0305 183.848 75.1919 183.611C74.6697 178.326 76.1571 174.955 80.8409 173.484C84.781 172.25 86.5848 174.164 86.6956 175.62V175.604Z",
    fill: "url(#paint62_linear_10512_2972)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M101.017 194.988C101.095 195.114 101.142 195.114 101.111 194.988H101.017Z",
    fill: "#7E8082"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M101 194.988C100.715 194.735 99.9241 193.327 99.0538 191.554C98.0727 189.545 97.2974 187.899 97.5664 187.773C97.8354 187.646 98.6424 189.26 99.6234 191.285C100.494 193.073 101.079 194.624 101.111 195.004H101V194.988Z",
    fill: "url(#paint63_linear_10512_2972)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5195 190.426L99.0884 190.148L99.2757 190.532L98.7068 190.81L98.5195 190.426Z",
    fill: "url(#paint64_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M100.826 194.418C100.652 194.212 99.9241 192.725 99.2912 191.411C98.5633 189.924 97.7879 188.357 97.8987 188.294C98.0095 188.247 98.8165 189.797 99.5443 191.285C100.177 192.598 100.826 194.133 100.874 194.386H100.826V194.418Z",
    fill: "#A7AAAF"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5052 190.411L98.7469 190.293L98.9342 190.677L98.6925 190.795L98.5052 190.411Z",
    fill: "#A69B9B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M100.826 191.332C101 191.585 100.747 191.791 100.478 192.028C100.209 192.265 99.924 192.471 99.7341 192.281C99.5284 192.076 99.8291 191.68 100.13 191.427C100.367 191.221 100.636 191.063 100.826 191.332Z",
    fill: "#FFB182"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M101.538 192.154C101.728 192.376 101.475 192.708 101.174 193.056C100.873 193.42 100.478 193.816 100.272 193.61C100.082 193.404 100.415 192.945 100.747 192.566C101.032 192.233 101.332 191.933 101.538 192.154Z",
    fill: "#FFB182"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M101.665 192.788C101.807 192.962 101.649 193.278 101.427 193.563C101.19 193.864 100.873 194.149 100.683 194.038C100.478 193.911 100.763 193.5 101.016 193.183C101.221 192.914 101.49 192.566 101.68 192.804L101.665 192.788Z",
    fill: "#FFB182"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M101.269 191.726C101.443 191.979 101.222 192.217 100.953 192.517C100.652 192.85 100.32 193.135 100.067 192.961C99.7977 192.786 100.162 192.296 100.51 191.964C100.795 191.679 101.095 191.457 101.285 191.71L101.269 191.726Z",
    fill: "#FFB182"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1195 211.414C88.7683 211.446 90.4773 211.572 91.3001 211.683C92.1229 211.794 93.6261 212.522 93.5787 212.854C93.5312 213.202 92.4077 212.411 91.49 212.269C90.5722 212.126 88.1195 211.414 88.1195 211.414Z",
    fill: "url(#paint65_linear_10512_2972)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5182 213.154C88.1195 213.518 89.0214 213.707 90.1449 213.897C91.8538 214.198 92.2178 214.799 92.4393 214.451C92.645 214.135 90.6671 213.549 90.7462 213.423C90.8095 213.296 91.569 213.518 92.1545 213.755C92.8982 214.04 93.6102 214.435 93.721 214.198C93.8318 213.961 93.3254 213.755 92.5184 213.359C91.7589 212.98 91.1259 212.869 91.1259 212.726C91.1259 212.584 91.9962 212.964 92.7083 213.233C93.3096 213.454 93.9584 214.008 94.1483 213.739C94.2748 213.549 93.5311 213.09 92.7716 212.711C91.4582 212.046 90.4139 211.682 89.1955 211.508C88.6733 211.429 88.1353 211.413 88.1353 211.413C88.1353 211.413 88.1353 211.223 87.7397 212.062C87.3283 212.9 87.534 213.154 87.534 213.154H87.5182Z",
    fill: "url(#paint66_linear_10512_2972)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1197 211.414C87.4393 211.351 85.4613 210.781 85.4613 210.781L84.6385 212.807C84.6385 212.807 86.8063 212.965 87.5026 213.139C88.1988 213.313 88.1039 211.398 88.1039 211.398L88.1197 211.414Z",
    fill: "url(#paint67_linear_10512_2972)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4769 210.781C85.4769 210.781 87.0593 211.24 87.8821 211.367C87.803 211.746 87.6764 212.822 88.6416 213.281C89.6543 213.772 90.3348 213.851 90.8569 214.041C90.6512 213.993 90.4297 213.93 90.1765 213.883C89.053 213.677 88.1511 213.503 87.5498 213.139C86.8536 212.965 84.6857 212.807 84.6857 212.807L85.5086 210.781H85.4769Z",
    fill: "#C4694D"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4524 194.64C98.3575 193.77 98.5315 192.947 98.7214 192.378C98.848 191.998 99.1487 191.001 99.4018 191.049C99.7974 191.128 99.5601 192.03 99.4651 192.425C99.3227 193.011 99.8449 193.39 99.8924 193.881C100.003 195.321 98.579 195.748 98.4682 194.64H98.4524Z",
    fill: "#FFB182"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0559 192.946C76.0147 192.851 71.4891 206.649 72.9765 209.576C74.6855 212.931 84.1322 213.706 86.5532 213.738C86.5532 213.738 87.9456 212.14 86.9013 210.004C86.9013 210.004 79.5591 207.329 78.7996 206.522C78.0401 205.715 83.8631 193.199 78.0717 192.946H78.0559Z",
    fill: "url(#paint68_linear_10512_2972)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M105.921 217.772V216.965C105.921 216.965 104.829 216.031 102.298 216.047C99.7658 216.047 96.3004 216.063 93.8952 216.079C91.5059 216.079 90.3191 216.822 90.3191 216.822V217.803L105.921 217.772Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6485 214.862C99.6234 214.783 102.661 214.862 105.367 215.068C101.886 215.068 99.5917 215.653 98.4208 217.093L89.6861 217.125C91.3002 215.084 96.6485 214.862 96.6485 214.862Z",
    fill: "#EDD8CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4238 217.125L92.7086 215.479C92.9618 215.416 93.2308 215.337 93.4839 215.289C94.0694 215.495 95.0188 215.748 96.2531 215.843C98.4367 216.017 100.937 215.574 100.937 215.574C99.8292 215.906 98.9905 216.397 98.4209 217.109H92.4238V217.125Z",
    fill: "#CEB6AA"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5654 217.157L81.7109 217.11V216.841C81.7109 216.841 82.8819 216.097 85.2871 216.097C86.9011 216.097 89.0056 216.097 90.9836 216.081C91.6323 215.86 92.7558 215.591 94.4173 215.638C97.2813 215.717 98.1991 217.094 98.1991 217.094L97.313 217.062V217.806L81.7268 217.838V217.252L82.5812 217.173L82.5654 217.157Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5656 217.157L81.6795 217.109V216.84L90.6198 216.809V217.805L81.6795 217.821V217.236L82.5656 217.157Z",
    fill: "#B29B93"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M106.016 217.772V216.965C106.016 216.965 104.924 216.031 102.392 216.047C99.8607 216.047 98.4366 217.076 98.4366 217.076C98.4366 217.076 96.3953 216.063 94.0059 216.079C91.6166 216.079 90.4298 216.822 90.4298 216.822V217.803L106.032 217.772H106.016Z",
    fill: "#FAE7DC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1708 217.791L106.69 217.742L106.692 218.296L90.1724 218.345L90.1708 217.791Z",
    fill: "url(#paint69_linear_10512_2972)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8984 217.819L90.2026 217.791L90.2042 218.345L80.9 218.372L80.8984 217.819Z",
    fill: "url(#paint70_linear_10512_2972)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4841 217.156C100.304 214.894 105.32 215.242 105.367 215.242V215.084C105.162 215.068 100.24 214.735 98.3733 217.062L98.4999 217.156H98.4841Z",
    fill: "#FAE7DC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8511 217.757H98.9904C98.9904 217.757 98.6898 217.188 98.4208 217.188C98.1518 217.188 97.8511 217.757 97.8511 217.757Z",
    fill: "url(#paint71_linear_10512_2972)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M86.031 215.226C86.031 215.226 86.838 215.321 87.8507 215.78L96.0789 216.144L98.1044 216.792C98.1044 216.792 96.8543 215.178 92.5028 214.894C88.6102 214.64 86.0152 215.226 86.0152 215.226H86.031Z",
    fill: "#CEB6AA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4298 216.301L81.6951 216.191C81.6951 216.191 83.1035 215.827 85.4928 215.668C87.8822 215.51 93.5628 215.289 95.7148 215.858C95.7148 215.858 92.9932 215.447 90.4298 216.317V216.301Z",
    fill: "#EDD8CA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8729 215.21L82.1384 215.146C82.1384 215.146 83.5466 214.767 85.936 214.577C87.8981 214.419 94.1326 214.118 96.9017 215.795C96.9017 215.795 93.8636 214.624 90.8571 215.21H90.8729Z",
    fill: "#EDD8CA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3099 217.157L98.4048 217.03C95.3509 214.657 90.6988 216.049 90.4298 216.144L81.6793 216.176V216.334L90.4614 216.302C90.4614 216.302 95.2401 214.783 98.3099 217.157Z",
    fill: "#FAE7DC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2941 217.139L98.4207 217.044C96.3952 214.259 90.9361 215.114 90.8728 215.114L82.1224 215.145V215.304L90.8728 215.272C90.8728 215.272 96.3161 214.418 98.2782 217.139H98.2941Z",
    fill: "#FAE7DC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2972 217.044C97.2972 217.044 96.9491 216.87 96.3795 216.696C95.8098 216.537 95.0345 216.395 94.2433 216.363C92.6609 216.363 91.1577 216.854 91.1577 216.854C91.1577 216.854 92.6926 216.442 94.2433 216.522C95.0186 216.522 95.794 216.601 96.3636 216.743C96.9333 216.87 97.2972 217.044 97.2972 217.044Z",
    fill: "#D8C0B6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8384 217.297C96.8384 217.297 95.889 217.059 94.9238 216.996C93.9427 216.996 92.9775 217.123 92.9775 217.123C92.9775 217.123 93.9427 217.075 94.908 217.154C95.8732 217.154 96.8384 217.297 96.8384 217.297Z",
    fill: "#D8C0B6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M99.212 217.06C99.212 217.06 99.5918 216.902 100.193 216.759C100.794 216.617 101.601 216.506 102.424 216.522C104.07 216.427 105.652 216.996 105.652 216.996C105.652 216.996 104.102 216.348 102.424 216.364C101.601 216.395 100.779 216.538 100.177 216.712C99.576 216.87 99.212 217.06 99.212 217.06Z",
    fill: "#D8C0B6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M104.402 217.408C104.402 217.408 103.231 217.139 102.029 217.155C100.826 217.202 99.6709 217.519 99.6709 217.519C99.6709 217.519 100.842 217.282 102.029 217.297C103.215 217.218 104.402 217.392 104.402 217.392V217.408Z",
    fill: "#D8C0B6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8984 217.819L90.2026 217.791L90.2042 218.345L80.9 218.372L80.8984 217.819Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8153 208.596C75.4609 211.824 84.3063 212.663 87.0912 212.742C86.8697 213.359 86.5533 213.723 86.5533 213.723C84.1481 213.691 74.6856 212.916 72.9766 209.561C71.6158 206.871 75.3343 194.94 77.5338 193.152C76.6793 194.339 72.4386 205.874 73.7995 208.58L73.8153 208.596Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3155 176.68C75.8566 177.756 75.904 179.164 77.7079 179.575C80.7935 180.287 85.6514 177.613 85.952 175.414C86.0628 174.575 85.8887 174.005 85.2874 173.578C86.1894 174.084 86.6482 174.907 86.7115 175.604C86.8539 177.455 84.069 178.436 82.7082 179.37C82.2968 179.654 81.9328 180.002 81.6322 180.414C81.1258 181.11 80.8568 182.012 80.7935 182.724C80.7935 183.5 80.9359 184.18 80.3505 184.291C79.7333 184.417 79.3694 183.025 79.3694 183.025L79.4644 182.993C79.3536 183.025 76.2205 183.784 75.2869 183.61C75.2553 183.515 75.2236 183.405 75.192 183.294C74.9546 180.556 75.2869 178.357 76.3313 176.68H76.3155Z",
    fill: "#491D17"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M23.46 63L28.58 49H31.46L36.58 63H33.86L32.74 59.76H27.28L26.14 63H23.46ZM27.98 57.76H32.04L30 51.94L27.98 57.76ZM42.4947 63.24C41.4814 63.24 40.588 63.02 39.8147 62.58C39.0414 62.14 38.428 61.5267 37.9747 60.74C37.5347 59.9533 37.3147 59.0533 37.3147 58.04C37.3147 57.0267 37.5347 56.1267 37.9747 55.34C38.428 54.5533 39.0414 53.94 39.8147 53.5C40.588 53.06 41.4814 52.84 42.4947 52.84C43.7614 52.84 44.828 53.1733 45.6947 53.84C46.5614 54.4933 47.1147 55.4 47.3547 56.56H44.6547C44.5214 56.08 44.2547 55.7067 43.8547 55.44C43.468 55.16 43.008 55.02 42.4747 55.02C41.768 55.02 41.168 55.2867 40.6747 55.82C40.1814 56.3533 39.9347 57.0933 39.9347 58.04C39.9347 58.9867 40.1814 59.7267 40.6747 60.26C41.168 60.7933 41.768 61.06 42.4747 61.06C43.008 61.06 43.468 60.9267 43.8547 60.66C44.2547 60.3933 44.5214 60.0133 44.6547 59.52H47.3547C47.1147 60.64 46.5614 61.54 45.6947 62.22C44.828 62.9 43.7614 63.24 42.4947 63.24ZM52.8269 63.24C51.9735 63.24 51.2735 63.1067 50.7269 62.84C50.1802 62.56 49.7735 62.1933 49.5069 61.74C49.2402 61.2867 49.1069 60.7867 49.1069 60.24C49.1069 59.32 49.4669 58.5733 50.1869 58C50.9069 57.4267 51.9869 57.14 53.4269 57.14H55.9469V56.9C55.9469 56.22 55.7535 55.72 55.3669 55.4C54.9802 55.08 54.5002 54.92 53.9269 54.92C53.4069 54.92 52.9535 55.0467 52.5669 55.3C52.1802 55.54 51.9402 55.9 51.8469 56.38H49.3469C49.4135 55.66 49.6535 55.0333 50.0669 54.5C50.4935 53.9667 51.0402 53.56 51.7069 53.28C52.3735 52.9867 53.1202 52.84 53.9469 52.84C55.3602 52.84 56.4735 53.1933 57.2869 53.9C58.1002 54.6067 58.5069 55.6067 58.5069 56.9V63H56.3269L56.0869 61.4C55.7935 61.9333 55.3802 62.3733 54.8469 62.72C54.3269 63.0667 53.6535 63.24 52.8269 63.24ZM53.4069 61.24C54.1402 61.24 54.7069 61 55.1069 60.52C55.5202 60.04 55.7802 59.4467 55.8869 58.74H53.7069C53.0269 58.74 52.5402 58.8667 52.2469 59.12C51.9535 59.36 51.8069 59.66 51.8069 60.02C51.8069 60.4067 51.9535 60.7067 52.2469 60.92C52.5402 61.1333 52.9269 61.24 53.4069 61.24ZM65.2898 63.24C64.3565 63.24 63.5232 63.0133 62.7898 62.56C62.0565 62.1067 61.4765 61.4867 61.0498 60.7C60.6232 59.9133 60.4098 59.02 60.4098 58.02C60.4098 57.02 60.6232 56.1333 61.0498 55.36C61.4765 54.5733 62.0565 53.96 62.7898 53.52C63.5232 53.0667 64.3565 52.84 65.2898 52.84C66.0365 52.84 66.6898 52.98 67.2498 53.26C67.8098 53.54 68.2632 53.9333 68.6098 54.44V48.6H71.1698V63H68.8898L68.6098 61.58C68.2898 62.02 67.8632 62.4067 67.3298 62.74C66.8098 63.0733 66.1298 63.24 65.2898 63.24ZM65.8298 61C66.6565 61 67.3298 60.7267 67.8498 60.18C68.3832 59.62 68.6498 58.9067 68.6498 58.04C68.6498 57.1733 68.3832 56.4667 67.8498 55.92C67.3298 55.36 66.6565 55.08 65.8298 55.08C65.0165 55.08 64.3432 55.3533 63.8098 55.9C63.2765 56.4467 63.0098 57.1533 63.0098 58.02C63.0098 58.8867 63.2765 59.6 63.8098 60.16C64.3432 60.72 65.0165 61 65.8298 61ZM78.3767 63.24C77.3767 63.24 76.4901 63.0267 75.7167 62.6C74.9434 62.1733 74.3367 61.5733 73.8967 60.8C73.4567 60.0267 73.2367 59.1333 73.2367 58.12C73.2367 57.0933 73.4501 56.18 73.8767 55.38C74.3167 54.58 74.9167 53.96 75.6767 53.52C76.4501 53.0667 77.3567 52.84 78.3967 52.84C79.3701 52.84 80.2301 53.0533 80.9767 53.48C81.7234 53.9067 82.3034 54.4933 82.7167 55.24C83.1434 55.9733 83.3567 56.7933 83.3567 57.7C83.3567 57.8467 83.3501 58 83.3367 58.16C83.3367 58.32 83.3301 58.4867 83.3167 58.66H75.7767C75.8301 59.4333 76.0967 60.04 76.5767 60.48C77.0701 60.92 77.6634 61.14 78.3567 61.14C78.8767 61.14 79.3101 61.0267 79.6567 60.8C80.0167 60.56 80.2834 60.2533 80.4567 59.88H83.0567C82.8701 60.5067 82.5567 61.08 82.1167 61.6C81.6901 62.1067 81.1567 62.5067 80.5167 62.8C79.8901 63.0933 79.1767 63.24 78.3767 63.24ZM78.3967 54.92C77.7701 54.92 77.2167 55.1 76.7367 55.46C76.2567 55.8067 75.9501 56.34 75.8167 57.06H80.7567C80.7167 56.4067 80.4767 55.8867 80.0367 55.5C79.5967 55.1133 79.0501 54.92 78.3967 54.92ZM85.2898 63V53.08H87.5498L87.7698 54.42C88.0898 53.94 88.5098 53.56 89.0298 53.28C89.5632 52.9867 90.1765 52.84 90.8698 52.84C92.4032 52.84 93.4898 53.4333 94.1298 54.62C94.4898 54.0733 94.9698 53.64 95.5698 53.32C96.1832 53 96.8498 52.84 97.5698 52.84C98.8632 52.84 99.8565 53.2267 100.55 54C101.243 54.7733 101.59 55.9067 101.59 57.4V63H99.0298V57.64C99.0298 56.7867 98.8632 56.1333 98.5298 55.68C98.2098 55.2267 97.7098 55 97.0298 55C96.3365 55 95.7765 55.2533 95.3498 55.76C94.9365 56.2667 94.7298 56.9733 94.7298 57.88V63H92.1698V57.64C92.1698 56.7867 92.0032 56.1333 91.6698 55.68C91.3365 55.2267 90.8232 55 90.1298 55C89.4498 55 88.8965 55.2533 88.4698 55.76C88.0565 56.2667 87.8498 56.9733 87.8498 57.88V63H85.2898ZM105.18 51.54C104.714 51.54 104.327 51.4 104.02 51.12C103.727 50.84 103.58 50.4867 103.58 50.06C103.58 49.6333 103.727 49.2867 104.02 49.02C104.327 48.74 104.714 48.6 105.18 48.6C105.647 48.6 106.027 48.74 106.32 49.02C106.627 49.2867 106.78 49.6333 106.78 50.06C106.78 50.4867 106.627 50.84 106.32 51.12C106.027 51.4 105.647 51.54 105.18 51.54ZM103.9 63V53.08H106.46V63H103.9ZM113.772 63.24C112.759 63.24 111.866 63.02 111.092 62.58C110.319 62.14 109.706 61.5267 109.252 60.74C108.812 59.9533 108.592 59.0533 108.592 58.04C108.592 57.0267 108.812 56.1267 109.252 55.34C109.706 54.5533 110.319 53.94 111.092 53.5C111.866 53.06 112.759 52.84 113.772 52.84C115.039 52.84 116.106 53.1733 116.972 53.84C117.839 54.4933 118.392 55.4 118.632 56.56H115.932C115.799 56.08 115.532 55.7067 115.132 55.44C114.746 55.16 114.286 55.02 113.752 55.02C113.046 55.02 112.446 55.2867 111.952 55.82C111.459 56.3533 111.212 57.0933 111.212 58.04C111.212 58.9867 111.459 59.7267 111.952 60.26C112.446 60.7933 113.046 61.06 113.752 61.06C114.286 61.06 114.746 60.9267 115.132 60.66C115.532 60.3933 115.799 60.0133 115.932 59.52H118.632C118.392 60.64 117.839 61.54 116.972 62.22C116.106 62.9 115.039 63.24 113.772 63.24ZM30.92 89.24C29.52 89.24 28.2933 88.9333 27.24 88.32C26.2 87.7067 25.38 86.86 24.78 85.78C24.1933 84.6867 23.9 83.4267 23.9 82C23.9 80.5733 24.1933 79.32 24.78 78.24C25.38 77.1467 26.2 76.2933 27.24 75.68C28.2933 75.0667 29.52 74.76 30.92 74.76C32.3067 74.76 33.5267 75.0667 34.58 75.68C35.6333 76.2933 36.4533 77.1467 37.04 78.24C37.6267 79.32 37.92 80.5733 37.92 82C37.92 83.4267 37.6267 84.6867 37.04 85.78C36.4533 86.86 35.6333 87.7067 34.58 88.32C33.5267 88.9333 32.3067 89.24 30.92 89.24ZM30.92 86.94C32.2533 86.94 33.3133 86.5 34.1 85.62C34.9 84.74 35.3 83.5333 35.3 82C35.3 80.4667 34.9 79.26 34.1 78.38C33.3133 77.5 32.2533 77.06 30.92 77.06C29.5867 77.06 28.52 77.5 27.72 78.38C26.92 79.26 26.52 80.4667 26.52 82C26.52 83.5333 26.92 84.74 27.72 85.62C28.52 86.5 29.5867 86.94 30.92 86.94ZM39.9003 93.4V79.08H42.1803L42.4603 80.5C42.7803 80.06 43.2003 79.6733 43.7203 79.34C44.2536 79.0067 44.9403 78.84 45.7803 78.84C46.7136 78.84 47.547 79.0667 48.2803 79.52C49.0136 79.9733 49.5936 80.5933 50.0203 81.38C50.447 82.1667 50.6603 83.06 50.6603 84.06C50.6603 85.06 50.447 85.9533 50.0203 86.74C49.5936 87.5133 49.0136 88.1267 48.2803 88.58C47.547 89.02 46.7136 89.24 45.7803 89.24C45.0336 89.24 44.3803 89.1 43.8203 88.82C43.2603 88.54 42.807 88.1467 42.4603 87.64V93.4H39.9003ZM45.2403 87C46.0536 87 46.727 86.7267 47.2603 86.18C47.7936 85.6333 48.0603 84.9267 48.0603 84.06C48.0603 83.1933 47.7936 82.48 47.2603 81.92C46.727 81.36 46.0536 81.08 45.2403 81.08C44.4136 81.08 43.7336 81.36 43.2003 81.92C42.6803 82.4667 42.4203 83.1733 42.4203 84.04C42.4203 84.9067 42.6803 85.62 43.2003 86.18C43.7336 86.7267 44.4136 87 45.2403 87ZM57.5472 89.24C56.5472 89.24 55.6605 89.0267 54.8872 88.6C54.1139 88.1733 53.5072 87.5733 53.0672 86.8C52.6272 86.0267 52.4072 85.1333 52.4072 84.12C52.4072 83.0933 52.6205 82.18 53.0472 81.38C53.4872 80.58 54.0872 79.96 54.8472 79.52C55.6205 79.0667 56.5272 78.84 57.5672 78.84C58.5405 78.84 59.4005 79.0533 60.1472 79.48C60.8939 79.9067 61.4739 80.4933 61.8872 81.24C62.3139 81.9733 62.5272 82.7933 62.5272 83.7C62.5272 83.8467 62.5205 84 62.5072 84.16C62.5072 84.32 62.5005 84.4867 62.4872 84.66H54.9472C55.0005 85.4333 55.2672 86.04 55.7472 86.48C56.2405 86.92 56.8339 87.14 57.5272 87.14C58.0472 87.14 58.4805 87.0267 58.8272 86.8C59.1872 86.56 59.4539 86.2533 59.6272 85.88H62.2272C62.0405 86.5067 61.7272 87.08 61.2872 87.6C60.8605 88.1067 60.3272 88.5067 59.6872 88.8C59.0605 89.0933 58.3472 89.24 57.5472 89.24ZM57.5672 80.92C56.9405 80.92 56.3872 81.1 55.9072 81.46C55.4272 81.8067 55.1205 82.34 54.9872 83.06H59.9272C59.8872 82.4067 59.6472 81.8867 59.2072 81.5C58.7672 81.1133 58.2205 80.92 57.5672 80.92ZM64.4603 89V79.08H66.7403L66.9803 80.94C67.3403 80.3 67.827 79.7933 68.4403 79.42C69.067 79.0333 69.8003 78.84 70.6403 78.84V81.54H69.9203C69.3603 81.54 68.8603 81.6267 68.4203 81.8C67.9803 81.9733 67.6336 82.2733 67.3803 82.7C67.1403 83.1267 67.0203 83.72 67.0203 84.48V89H64.4603ZM75.59 89.24C74.7367 89.24 74.0367 89.1067 73.49 88.84C72.9433 88.56 72.5367 88.1933 72.27 87.74C72.0033 87.2867 71.87 86.7867 71.87 86.24C71.87 85.32 72.23 84.5733 72.95 84C73.67 83.4267 74.75 83.14 76.19 83.14H78.71V82.9C78.71 82.22 78.5167 81.72 78.13 81.4C77.7433 81.08 77.2633 80.92 76.69 80.92C76.17 80.92 75.7167 81.0467 75.33 81.3C74.9433 81.54 74.7033 81.9 74.61 82.38H72.11C72.1767 81.66 72.4167 81.0333 72.83 80.5C73.2567 79.9667 73.8033 79.56 74.47 79.28C75.1367 78.9867 75.8833 78.84 76.71 78.84C78.1233 78.84 79.2367 79.1933 80.05 79.9C80.8633 80.6067 81.27 81.6067 81.27 82.9V89H79.09L78.85 87.4C78.5567 87.9333 78.1433 88.3733 77.61 88.72C77.09 89.0667 76.4167 89.24 75.59 89.24ZM76.17 87.24C76.9033 87.24 77.47 87 77.87 86.52C78.2833 86.04 78.5433 85.4467 78.65 84.74H76.47C75.79 84.74 75.3033 84.8667 75.01 85.12C74.7167 85.36 74.57 85.66 74.57 86.02C74.57 86.4067 74.7167 86.7067 75.01 86.92C75.3033 87.1333 75.69 87.24 76.17 87.24ZM87.7763 89C86.7363 89 85.9029 88.7467 85.2763 88.24C84.6496 87.7333 84.3363 86.8333 84.3363 85.54V81.22H82.6363V79.08H84.3363L84.6363 76.42H86.8963V79.08H89.5763V81.22H86.8963V85.56C86.8963 86.04 86.9963 86.3733 87.1963 86.56C87.4096 86.7333 87.7696 86.82 88.2763 86.82H89.5163V89H87.7763ZM92.9342 77.54C92.4676 77.54 92.0809 77.4 91.7742 77.12C91.4809 76.84 91.3342 76.4867 91.3342 76.06C91.3342 75.6333 91.4809 75.2867 91.7742 75.02C92.0809 74.74 92.4676 74.6 92.9342 74.6C93.4009 74.6 93.7809 74.74 94.0742 75.02C94.3809 75.2867 94.5342 75.6333 94.5342 76.06C94.5342 76.4867 94.3809 76.84 94.0742 77.12C93.7809 77.4 93.4009 77.54 92.9342 77.54ZM91.6542 89V79.08H94.2142V89H91.6542ZM96.6662 89V79.08H98.9262L99.1262 80.76C99.4329 80.1733 99.8729 79.7067 100.446 79.36C101.033 79.0133 101.72 78.84 102.506 78.84C103.733 78.84 104.686 79.2267 105.366 80C106.046 80.7733 106.386 81.9067 106.386 83.4V89H103.826V83.64C103.826 82.7867 103.653 82.1333 103.306 81.68C102.96 81.2267 102.42 81 101.686 81C100.966 81 100.373 81.2533 99.9062 81.76C99.4529 82.2667 99.2262 82.9733 99.2262 83.88V89H96.6662ZM112.814 86.04C112.334 86.04 111.888 85.9867 111.474 85.88L110.734 86.62C110.961 86.74 111.268 86.84 111.654 86.92C112.041 87 112.668 87.08 113.534 87.16C114.854 87.28 115.814 87.5933 116.414 88.1C117.014 88.6067 117.314 89.3067 117.314 90.2C117.314 90.7867 117.154 91.34 116.834 91.86C116.514 92.3933 116.021 92.82 115.354 93.14C114.688 93.4733 113.834 93.64 112.794 93.64C111.381 93.64 110.241 93.3733 109.374 92.84C108.508 92.32 108.074 91.5333 108.074 90.48C108.074 89.5867 108.508 88.8133 109.374 88.16C109.108 88.04 108.874 87.9133 108.674 87.78C108.488 87.6467 108.321 87.5067 108.174 87.36V86.9L109.914 85.06C109.141 84.38 108.754 83.5067 108.754 82.44C108.754 81.7733 108.914 81.1667 109.234 80.62C109.568 80.0733 110.034 79.64 110.634 79.32C111.234 79 111.961 78.84 112.814 78.84C113.374 78.84 113.894 78.92 114.374 79.08H118.134V80.64L116.434 80.76C116.701 81.2667 116.834 81.8267 116.834 82.44C116.834 83.1067 116.674 83.7133 116.354 84.26C116.034 84.8067 115.568 85.24 114.954 85.56C114.354 85.88 113.641 86.04 112.814 86.04ZM112.814 84.08C113.334 84.08 113.761 83.94 114.094 83.66C114.441 83.38 114.614 82.98 114.614 82.46C114.614 81.94 114.441 81.54 114.094 81.26C113.761 80.98 113.334 80.84 112.814 80.84C112.268 80.84 111.828 80.98 111.494 81.26C111.161 81.54 110.994 81.94 110.994 82.46C110.994 82.98 111.161 83.38 111.494 83.66C111.828 83.94 112.268 84.08 112.814 84.08ZM110.414 90.22C110.414 90.7133 110.641 91.08 111.094 91.32C111.561 91.5733 112.128 91.7 112.794 91.7C113.434 91.7 113.954 91.5667 114.354 91.3C114.754 91.0467 114.954 90.7 114.954 90.26C114.954 89.9 114.821 89.6 114.554 89.36C114.301 89.12 113.788 88.9733 113.014 88.92C112.468 88.88 111.961 88.82 111.494 88.74C111.108 88.9533 110.828 89.1867 110.654 89.44C110.494 89.6933 110.414 89.9533 110.414 90.22ZM29.14 115.24C28.1133 115.24 27.2067 115.067 26.42 114.72C25.6333 114.36 25.0133 113.853 24.56 113.2C24.1067 112.533 23.8733 111.727 23.86 110.78H26.56C26.5867 111.433 26.82 111.987 27.26 112.44C27.7133 112.88 28.3333 113.1 29.12 113.1C29.8 113.1 30.34 112.94 30.74 112.62C31.14 112.287 31.34 111.847 31.34 111.3C31.34 110.727 31.16 110.28 30.8 109.96C30.4533 109.64 29.9867 109.38 29.4 109.18C28.8133 108.98 28.1867 108.767 27.52 108.54C26.44 108.167 25.6133 107.687 25.04 107.1C24.48 106.513 24.2 105.733 24.2 104.76C24.1867 103.933 24.38 103.227 24.78 102.64C25.1933 102.04 25.7533 101.58 26.46 101.26C27.1667 100.927 27.98 100.76 28.9 100.76C29.8333 100.76 30.6533 100.927 31.36 101.26C32.08 101.593 32.64 102.06 33.04 102.66C33.4533 103.26 33.6733 103.973 33.7 104.8H30.96C30.9467 104.307 30.7533 103.873 30.38 103.5C30.02 103.113 29.5133 102.92 28.86 102.92C28.3 102.907 27.8267 103.047 27.44 103.34C27.0667 103.62 26.88 104.033 26.88 104.58C26.88 105.047 27.0267 105.42 27.32 105.7C27.6133 105.967 28.0133 106.193 28.52 106.38C29.0267 106.567 29.6067 106.767 30.26 106.98C30.9533 107.22 31.5867 107.5 32.16 107.82C32.7333 108.14 33.1933 108.567 33.54 109.1C33.8867 109.62 34.06 110.293 34.06 111.12C34.06 111.853 33.8733 112.533 33.5 113.16C33.1267 113.787 32.5733 114.293 31.84 114.68C31.1067 115.053 30.2067 115.24 29.14 115.24ZM37.2536 119.4L39.5536 114.34H38.9536L35.0936 105.08H37.8736L40.6536 112.06L43.5536 105.08H46.2736L39.9736 119.4H37.2536ZM51.3389 115.24C50.4589 115.24 49.6856 115.1 49.0189 114.82C48.3522 114.527 47.8189 114.127 47.4189 113.62C47.0189 113.113 46.7789 112.527 46.6989 111.86H49.2789C49.3589 112.247 49.5722 112.58 49.9189 112.86C50.2789 113.127 50.7389 113.26 51.2989 113.26C51.8589 113.26 52.2656 113.147 52.5189 112.92C52.7856 112.693 52.9189 112.433 52.9189 112.14C52.9189 111.713 52.7322 111.427 52.3589 111.28C51.9856 111.12 51.4656 110.967 50.7989 110.82C50.3722 110.727 49.9389 110.613 49.4989 110.48C49.0589 110.347 48.6522 110.18 48.2789 109.98C47.9189 109.767 47.6256 109.5 47.3989 109.18C47.1722 108.847 47.0589 108.44 47.0589 107.96C47.0589 107.08 47.4056 106.34 48.0989 105.74C48.8056 105.14 49.7922 104.84 51.0589 104.84C52.2322 104.84 53.1656 105.113 53.8589 105.66C54.5656 106.207 54.9856 106.96 55.1189 107.92H52.6989C52.5522 107.187 51.9989 106.82 51.0389 106.82C50.5589 106.82 50.1856 106.913 49.9189 107.1C49.6656 107.287 49.5389 107.52 49.5389 107.8C49.5389 108.093 49.7322 108.327 50.1189 108.5C50.5056 108.673 51.0189 108.833 51.6589 108.98C52.3522 109.14 52.9856 109.32 53.5589 109.52C54.1456 109.707 54.6122 109.993 54.9589 110.38C55.3056 110.753 55.4789 111.293 55.4789 112C55.4922 112.613 55.3322 113.167 54.9989 113.66C54.6656 114.153 54.1856 114.54 53.5589 114.82C52.9322 115.1 52.1922 115.24 51.3389 115.24ZM61.6342 115C60.5942 115 59.7609 114.747 59.1342 114.24C58.5076 113.733 58.1942 112.833 58.1942 111.54V107.22H56.4942V105.08H58.1942L58.4942 102.42H60.7542V105.08H63.4342V107.22H60.7542V111.56C60.7542 112.04 60.8542 112.373 61.0542 112.56C61.2676 112.733 61.6276 112.82 62.1342 112.82H63.3742V115H61.6342ZM69.9783 115.24C68.9783 115.24 68.0916 115.027 67.3183 114.6C66.5449 114.173 65.9383 113.573 65.4983 112.8C65.0583 112.027 64.8383 111.133 64.8383 110.12C64.8383 109.093 65.0516 108.18 65.4783 107.38C65.9183 106.58 66.5183 105.96 67.2783 105.52C68.0516 105.067 68.9583 104.84 69.9983 104.84C70.9716 104.84 71.8316 105.053 72.5783 105.48C73.3249 105.907 73.9049 106.493 74.3183 107.24C74.7449 107.973 74.9583 108.793 74.9583 109.7C74.9583 109.847 74.9516 110 74.9383 110.16C74.9383 110.32 74.9316 110.487 74.9183 110.66H67.3783C67.4316 111.433 67.6983 112.04 68.1783 112.48C68.6716 112.92 69.2649 113.14 69.9583 113.14C70.4783 113.14 70.9116 113.027 71.2583 112.8C71.6183 112.56 71.8849 112.253 72.0583 111.88H74.6583C74.4716 112.507 74.1583 113.08 73.7183 113.6C73.2916 114.107 72.7583 114.507 72.1183 114.8C71.4916 115.093 70.7783 115.24 69.9783 115.24ZM69.9983 106.92C69.3716 106.92 68.8183 107.1 68.3383 107.46C67.8583 107.807 67.5516 108.34 67.4183 109.06H72.3583C72.3183 108.407 72.0783 107.887 71.6383 107.5C71.1983 107.113 70.6516 106.92 69.9983 106.92ZM76.8914 115V105.08H79.1514L79.3714 106.42C79.6914 105.94 80.1114 105.56 80.6314 105.28C81.1647 104.987 81.7781 104.84 82.4714 104.84C84.0047 104.84 85.0914 105.433 85.7314 106.62C86.0914 106.073 86.5714 105.64 87.1714 105.32C87.7847 105 88.4514 104.84 89.1714 104.84C90.4647 104.84 91.4581 105.227 92.1514 106C92.8447 106.773 93.1914 107.907 93.1914 109.4V115H90.6314V109.64C90.6314 108.787 90.4647 108.133 90.1314 107.68C89.8114 107.227 89.3114 107 88.6314 107C87.9381 107 87.3781 107.253 86.9514 107.76C86.5381 108.267 86.3314 108.973 86.3314 109.88V115H83.7714V109.64C83.7714 108.787 83.6047 108.133 83.2714 107.68C82.9381 107.227 82.4247 107 81.7314 107C81.0514 107 80.4981 107.253 80.0714 107.76C79.6581 108.267 79.4514 108.973 79.4514 109.88V115H76.8914Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_2972)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint72_linear_10512_2972)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint73_linear_10512_2972)"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3624 147.851C44.1258 147.613 44.1258 147.228 44.3624 146.989L46.7109 144.612H37.5053C37.1715 144.612 36.8985 144.337 36.8985 144.001C36.8985 143.665 37.1715 143.39 37.5053 143.39H46.7109L44.3564 141.019C44.1197 140.781 44.1197 140.396 44.3564 140.157C44.593 139.919 44.9753 139.919 45.212 140.157L48.6102 143.573C48.8469 143.812 48.8469 144.197 48.6102 144.435L45.2181 147.851C44.9814 148.083 44.593 148.083 44.3624 147.851Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10512_2972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9481 15.8595H44.2965V22.1487H48.4062V24.561H41.9481V15.8595ZM49.7062 15.8595H56.4997V17.9272H52.0126V19.2626H56.0804V21.1579H52.0126V22.5364H56.5417V24.6041H49.7062V15.8595ZM60.9868 15.8164H63.2513L66.8578 24.561H64.3417L63.7126 23.0103H60.4417L59.8546 24.561H57.3804L60.9868 15.8164ZM63.0417 21.1149L62.1191 18.6595L61.1546 21.1149H63.0417ZM67.9901 15.8595H71.261C74.2804 15.8595 76.0417 17.6256 76.0417 20.1672C76.0417 22.6656 74.2804 24.5179 71.2191 24.5179H67.9901V15.8595ZM71.261 22.4072C72.6449 22.4072 73.6094 21.6318 73.6094 20.2103V20.1672C73.6094 18.7887 72.6868 17.9703 71.261 17.9703H70.2965V22.4072H71.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0935 36.28L47.3161 35.5477L45.429 29.6031L49.329 28.3108L48.6161 26.0277L42.4935 28.0523L45.0935 36.28ZM30.5419 21.3323L31.2548 19.0492L37.0419 20.9877L38.929 15L41.1516 15.7323L38.5516 24.0031L30.5419 21.3323ZM44.3806 36.6677L42.4935 38.0892L38.8871 33.0062L30.3323 38.52L24 43L30.4581 33.0062L33.6871 27.6646L28.7387 23.96L30.1226 22.0215L37 27.1477L30.8774 35.9354L39.4323 29.6462L44.3806 36.6677Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_2972",
    x: 16,
    y: 125,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_2972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_2972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_2972",
    x1: 121.207,
    y1: 152,
    x2: 121.207,
    y2: 212.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_2972",
    x1: 121.207,
    y1: 203.884,
    x2: 121.207,
    y2: 221.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_2972",
    x1: 121.297,
    y1: 153.225,
    x2: 121.297,
    y2: 202.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_2972",
    x1: 107.506,
    y1: 152.306,
    x2: 133.546,
    y2: 158.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_2972",
    x1: 87.9003,
    y1: 171.2,
    x2: 87.9003,
    y2: 180.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_2972",
    x1: 89.1404,
    y1: 185.785,
    x2: 89.1404,
    y2: 194.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_2972",
    x1: 89.1405,
    y1: 191.299,
    x2: 89.1405,
    y2: 199.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_2972",
    x1: 95.88,
    y1: 185.785,
    x2: 95.88,
    y2: 194.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_2972",
    x1: 95.88,
    y1: 191.299,
    x2: 95.88,
    y2: 199.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10512_2972",
    x1: 102.62,
    y1: 185.785,
    x2: 102.62,
    y2: 194.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10512_2972",
    x1: 102.62,
    y1: 191.299,
    x2: 102.62,
    y2: 199.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10512_2972",
    x1: 114.873,
    y1: 185.785,
    x2: 114.873,
    y2: 194.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10512_2972",
    x1: 114.873,
    y1: 191.299,
    x2: 114.873,
    y2: 199.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10512_2972",
    x1: 121.613,
    y1: 185.785,
    x2: 121.613,
    y2: 194.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_2972",
    x1: 121.613,
    y1: 191.299,
    x2: 121.613,
    y2: 199.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_2972",
    x1: 128.352,
    y1: 185.785,
    x2: 128.352,
    y2: 194.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_2972",
    x1: 128.352,
    y1: 191.299,
    x2: 128.352,
    y2: 199.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_2972",
    x1: 139.993,
    y1: 186.398,
    x2: 139.993,
    y2: 194.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_2972",
    x1: 139.993,
    y1: 191.914,
    x2: 139.993,
    y2: 200.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_2972",
    x1: 146.733,
    y1: 186.398,
    x2: 146.733,
    y2: 194.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_2972",
    x1: 146.733,
    y1: 191.914,
    x2: 146.733,
    y2: 200.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_2972",
    x1: 153.473,
    y1: 186.398,
    x2: 153.473,
    y2: 194.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_2972",
    x1: 153.473,
    y1: 191.914,
    x2: 153.473,
    y2: 200.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_2972",
    x1: 113.633,
    y1: 170.588,
    x2: 113.633,
    y2: 179.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_2972",
    x1: 139.295,
    y1: 170.588,
    x2: 139.295,
    y2: 179.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_2972",
    x1: 147.331,
    y1: 153.564,
    x2: 147.331,
    y2: 159.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_2972",
    x1: 153.458,
    y1: 154.691,
    x2: 153.458,
    y2: 158.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_2972",
    x1: 121.207,
    y1: 223.755,
    x2: 121.207,
    y2: 209.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_2972",
    x1: 155.608,
    y1: 210.385,
    x2: 155.608,
    y2: 206.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_2972",
    x1: 181.726,
    y1: 184.908,
    x2: 181.726,
    y2: 234.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_2972",
    x1: 130.863,
    y1: 175.537,
    x2: 130.863,
    y2: 193.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_2972",
    x1: 136.721,
    y1: 173.621,
    x2: 135.824,
    y2: 199.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_2972",
    x1: 132.204,
    y1: 173.454,
    x2: 131.339,
    y2: 198.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_2972",
    x1: 130.196,
    y1: 173.199,
    x2: 129.272,
    y2: 199.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_2972",
    x1: 142.658,
    y1: 185.375,
    x2: 142.658,
    y2: 221.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_2972",
    x1: 163.636,
    y1: 185.258,
    x2: 163.659,
    y2: 228.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_2972",
    x1: 169.032,
    y1: 156.746,
    x2: 172.007,
    y2: 183.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_2972",
    x1: 168.151,
    y1: 189.389,
    x2: 168.747,
    y2: 176.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_2972",
    x1: 168.208,
    y1: 188.163,
    x2: 168.656,
    y2: 178.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_2972",
    x1: 164.809,
    y1: 160.228,
    x2: 158.998,
    y2: 188.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAD7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA9F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F48960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10512_2972",
    x1: 164.287,
    y1: 163.724,
    x2: 165.169,
    y2: 193.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3845C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10512_2972",
    x1: 166.433,
    y1: 157.878,
    x2: 169.241,
    y2: 183.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10512_2972",
    x1: 162.649,
    y1: 158.307,
    x2: 165.436,
    y2: 183.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10512_2972",
    x1: 164.32,
    y1: 184.83,
    x2: 164.32,
    y2: 199.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10512_2972",
    x1: 164.71,
    y1: 185.871,
    x2: 164.71,
    y2: 198.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10512_2972",
    x1: 164.71,
    y1: 186.454,
    x2: 164.71,
    y2: 195.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_10512_2972",
    x1: 83.8157,
    y1: 192.141,
    x2: 83.8157,
    y2: 248.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10512_2972",
    x1: 82.1383,
    y1: 173.214,
    x2: 82.1383,
    y2: 203.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_10512_2972",
    x1: 95.715,
    y1: 203.374,
    x2: 95.715,
    y2: 245.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_10512_2972",
    x1: 62.8019,
    y1: 203.466,
    x2: 62.8019,
    y2: 244.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10512_2972",
    x1: 84.9709,
    y1: 214.45,
    x2: 84.9709,
    y2: 256.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10512_2972",
    x1: 81.2996,
    y1: 214.353,
    x2: 81.2996,
    y2: 251.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10512_2972",
    x1: 105.816,
    y1: 183.385,
    x2: 95.094,
    y2: 206.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10512_2972",
    x1: 103.235,
    y1: 182.466,
    x2: 96.6693,
    y2: 206.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10512_2972",
    x1: 91.6166,
    y1: 190.985,
    x2: 91.6166,
    y2: 218.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10512_2972",
    x1: 87.0302,
    y1: 172.436,
    x2: 88.7871,
    y2: 204.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10512_2972",
    x1: 83.3568,
    y1: 190.984,
    x2: 83.3568,
    y2: 218.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10512_2972",
    x1: 83.689,
    y1: 196.966,
    x2: 83.689,
    y2: 183.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10512_2972",
    x1: 83.2934,
    y1: 195.289,
    x2: 83.2934,
    y2: 185.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10512_2972",
    x1: 82.491,
    y1: 176.551,
    x2: 89.5574,
    y2: 195.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10512_2972",
    x1: 77.4606,
    y1: 177.477,
    x2: 82.8823,
    y2: 196.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10512_2972",
    x1: 79.6496,
    y1: 175.41,
    x2: 80.9489,
    y2: 199.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10512_2972",
    x1: 80.5523,
    y1: 172.792,
    x2: 82.2988,
    y2: 204.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10512_2972",
    x1: 101.653,
    y1: 191.701,
    x2: 98.344,
    y2: 191.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10512_2972",
    x1: 99.9759,
    y1: 190.842,
    x2: 99.2257,
    y2: 190.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10512_2972",
    x1: 90.6194,
    y1: 211.012,
    x2: 93.1617,
    y2: 226.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_10512_2972",
    x1: 92.091,
    y1: 215.268,
    x2: 71.7619,
    y2: 185.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10512_2972",
    x1: 86.1054,
    y1: 210.693,
    x2: 88.9827,
    y2: 228.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10512_2972",
    x1: 79.9864,
    y1: 190.984,
    x2: 79.9864,
    y2: 218.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10512_2972",
    x1: 106.682,
    y1: 218.026,
    x2: 90.1625,
    y2: 218.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10512_2972",
    x1: 90.2101,
    y1: 218.074,
    x2: 80.9059,
    y2: 218.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10512_2972",
    x1: 98.9904,
    y1: 217.472,
    x2: 97.8511,
    y2: 217.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10512_2972",
    x1: 62,
    y1: 155,
    x2: 22.0901,
    y2: 150.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10512_2972",
    x1: 43,
    y1: 101.604,
    x2: 43,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_2972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10512_2972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(24 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosShort);
export default __webpack_public_path__ + "static/media/SOS_Short.be69c0d28faf71cc2d462fcb7996ac3d.svg";
export { ForwardRef as ReactComponent };